<template>
  <div class="cam-stream-container">
    <cam-stream v-for="stream in $store.getters[`${storeModuleKey}/streams`]" :key="stream.key" :isLive="stream.isLive" :device="stream.device"
      :from="stream.from" :to="stream.to" @close="() => $store.dispatch(`${storeModuleKey}/closeStream`, {key:stream.key})" />
  </div>
</template>

<script>

import CamStream from './CamStream.vue'
import storeModule from './storeModule.js'
import store from '@/store'
import { onUnmounted } from '@vue/composition-api'

export default {
  name: 'CamStreamContainer',
  components: {
    CamStream
  },
  setup(props, { root }) {

    if (!store.hasModule(storeModule.key))
      store.registerModule(storeModule.key, storeModule.module)

    onUnmounted(() => {
      if (store.hasModule(storeModule.key))
        store.unregisterModule(storeModule.key)
    })

    return { storeModuleKey:storeModule.key }
  }
}
</script>

<style lang="scss">
.cam-stream-container {
  position: absolute;
  width: 100% !important;
  height: 100% !important; 
  top: 0px; 
  left: 0px;
  z-index: 1000; 
  pointer-events: none;
}
</style>
